import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { withShadow, withEllipsis } from 'ui/styles';
import FormattedCurrencyNumber from 'common/formatted-currency-number/formatted-currency-number';

const BottomTriangle = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
  width: 190px;
  height: 110px;
  padding: 10px;
  position: relative;
  ${withShadow};
  border-radius: 5px;
  margin-left: -20px;
  margin-bottom: 25px;
  cursor: ${p => p.clickable && 'pointer'};

  ::after {
    content: '';
    position: absolute;
    box-shadow: rgba(0, 0, 0, 0.12) 2px 2px 2px;
    transform: rotate(45deg);
    bottom: -6px;
    /*left: 25px;*/
    border-width: 6px;
    border-style: solid;
    border-color: transparent #fff #fff transparent;
  }
`;

const Header = styled.div`
  font-weight: ${p => p.theme.fontWeight.bolder};
  text-transform: uppercase;
  margin-bottom: 0.25em;
  color: ${p => p.theme.colors.timeline[p.type]};
  border-bottom: 1px solid ${p => p.theme.colors.border};
`;

const Text = styled.p`
  color: ${p => p.theme.colors.textLight};
  font-size: 0.85rem;
  ${withEllipsis};
`;

const NoText = styled.div`
  font-size: 1rem;
  text-align: center;
  margin: auto;
`;

const Cost = styled.span`
  font-weight: ${p => p.theme.fontWeight.bolder};
  color: ${p => p.theme.colors.text};
`;

const getSerialNrLabel = (serialNumbers, equipmentIds) => {
  if (serialNumbers?.length) {
    if (serialNumbers.length > 1) {
      return (
        <span>
          {serialNumbers.length} <FormattedMessage id='dashboard.shortTermTimeline.EQUIPMENT' />
        </span>
      );
    }
    return (
      <span>
        <FormattedMessage id='dashboard.shortTermTimeline.EQUIPMENT_SERIALNUMBER' />:{' '}
        {serialNumbers[0]}
      </span>
    );
  } else if (equipmentIds?.length) {
    if (equipmentIds.length > 1) {
      return (
        <span>
          {equipmentIds.length} <FormattedMessage id='dashboard.shortTermTimeline.EQUIPMENT' />
        </span>
      );
    }
    return (
      <span>
        1 <FormattedMessage id='dashboard.shortTermTimeline.EQUIPMENT' />
      </span>
    );
  }
  return null;
};

const getFunctionalLocationsLabel = (functionalLocationIds) => {
  if (functionalLocationIds?.length) {
    if (functionalLocationIds.length > 1) {
      return (
        <span>
          {/* eslint-disable-next-line max-len */}
          {functionalLocationIds.length} <FormattedMessage id='dashboard.shortTermTimeline.FUNCTIONAL_LOCATION' />
        </span>
      );
    }
    return (
      <span>
        1 <FormattedMessage id='dashboard.shortTermTimeline.FUNCTIONAL_LOCATION' />
      </span>
    );
  }
  return null;
};

const SegmentInfo = ({ onClick, segment, isPresent = false, type }) => {
  if (segment) {
    return (
      <BottomTriangle clickable onClick={onClick}>
        <>
          <Header type={type}>
            {isPresent ?
              <FormattedMessage id='dashboard.shortTermTimeline.in_progress' />
              :
              segment.relativeNotation
            }
          </Header>
          <Text>
            <FormattedMessage id='dashboard.shortTermTimeline.COST' />:
            <Cost>
              {' '}
              {segment.costCurrency ?
                <FormattedCurrencyNumber
                  currency={segment.costCurrency}
                  // eslint-disable-next-line
                  style='currency'
                  value={segment.cost}
                /> :
                <FormattedNumber
                  value={segment.cost}
                />
              }
            </Cost>
          </Text>
          <Text>{getSerialNrLabel(segment.serialNumbers, segment.equipmentIds)}</Text>
          <Text>{getFunctionalLocationsLabel(segment.functionalLocationIds)}</Text>
        </>
      </BottomTriangle>
    );
  }
  return (
    <BottomTriangle>
      <NoText>
        <FormattedMessage id={`dashboard.shortTermTimeline.${type}_noData`} />
      </NoText>
    </BottomTriangle>
  );
};

SegmentInfo.propTypes = {
  segment: PropTypes.object,
  onClick: PropTypes.func.isRequired,
  isPresent: PropTypes.bool,
  type: PropTypes.string.isRequired,
};

export default SegmentInfo;
